import "./app-content.css";
import MapEmbed from "./map.js";

export const MessageAbove = () => {
    return (
        <div class="animation">
            <div class="timings">
                <p>Holy Mass Time: Mon,Wed-Sat: 6:25 am | Tue: 6:00 pm | Sun: 6:30 am, 09:30 am | First Fri: 6:00 pm</p>
            </div>

            <div class="scrolling-container">
                <div class="scrolling-images">
                    <img src="/images/Vasupuram Church.jpg" alt="St. Antony's Church" class="scrolling-img" />
                    <img src="/images/antony.jpg" alt="St. Antony's" class="scrolling-img" />
                    <img src="/images/cat-gp.jpg" alt="Catechism Teachers" class="scrolling-img" />
                    <img src="/images/parish_hall.jpg" alt="St. Antony's Parish Hall" class="scrolling-img" />
                    {/* eslint-disable-next-line */}
                    <img src="/images/Vasupuram Church.jpg" alt="St. Antony's Church 1" class="scrolling-img" />
                    {/* eslint-disable-next-line jsx-a11y/img-redundant-alt */}
                    <img src="/images/antony.jpg" alt="St. Antony's 1" class="scrolling-img" />
                    <img src="/images/cat-gp.jpg" alt="Catechism Teachers1" class="scrolling-img" />
                    <img src="/images/parish_hall.jpg" alt="St. Antony's Parish Hall 1" class="scrolling-img" />
                </div>
            </div>

            <div class="vicar-message">
                <div class="message-label">
                    <span>M</span>
                    <span>E</span>
                    <span>S</span>
                    <span>S</span>
                    <span>A</span>
                    <span>G</span>
                    <span>E</span>
                </div>
                <div class="vicar-section">
                    <div class="vicar-info">
                        <img src="/images/Fr_James.jpg" alt="Rev. Fr. James Athiyunthan" />
                        <h2>Rev. Fr. James Athiyunthan</h2>
                        <h3>(Vicar)</h3>
                    </div>
                    <div class="message-content">
                        <p>
                            Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsam ex, at iure dolores unde repellendus distinctio eligendi aut, incidunt eaque voluptate mollitia veritatis nobis accusamus deserunt. Autem eos ducimus cum!Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsam ex, at iure dolores unde repellendus distinctio eligendi aut, incidunt eaque voluptate mollitia veritatis nobis accusamus deserunt. Autem eos ducimus cum!Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsam ex, at iure dolores unde repellendus distinctio eligendi aut, incidunt eaque voluptate mollitia veritatis nobis accusamus deserunt. Autem eos ducimus cum!Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsam ex, at iure dolores unde repellendus distinctio eligendi aut, incidunt eaque voluptate mollitia veritatis nobis accusamus deserunt. Autem eos ducimus cum!Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsam ex, at iure dolores unde repellendus distinctio eligendi aut, incidunt eaque voluptate mollitia veritatis nobis accusamus deserunt. Autem eos ducimus cum!Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsam ex, at iure dolores unde repellendus distinctio eligendi aut, incidunt eaque voluptate mollitia veritatis nobis accusamus deserunt. Autem eos ducimus cum!Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsam ex, at iure dolores unde repellendus distinctio eligendi aut, incidunt eaque voluptate mollitia veritatis nobis accusamus deserunt. Autem eos ducimus cum!Lorem ipsum dolor sit amet consectetur adipisicing elit.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export const MessageBelow = () => {
    return (
        <div class="animation">
            <div class="after-message">
                <div class="after-left">
                    <img src="/images/antony.jpg" alt="St. Antony" class="st-antony" />
                    <h1 class="patron">St. Antony, Our Patron,<br /> Pray for Us!</h1>
                </div>
                <div class="after-right">
                    <video autoPlay muted loop playsInline class="rotate-video">
                        <source src="/images/1.mp4" type="video/mp4" />
                    </video>
                </div >
            </div>
            <hr class="gradient-line" />
            <footer>
                <div class="end-portion">
                    <div class="splits-left">
                        <MapEmbed />
                    </div>
                    <div class="splits-right">
                        <img src="/images/Pilgrims-of-Hope.jpg" alt="Logo of Jubilee Year 2025" />
                    </div>
                </div>
                <h1>Quick Links</h1>
                <ul>
                    <li><a href="https://www.vatican.va/content/vatican/en.html" className="catechism-link">Vatican</a></li>
                    <li><a href="https://www.cbci.in/" className="catechism-link">CBCI</a></li>
                    <li><a href="https://kcbc.co.in/" className="catechism-link">KCBC</a></li>
                    <li><a href="https://www.syromalabarchurch.in/" className="catechism-link">Syro-Malabar Church</a></li>
                    <li><a href="https://www.syromalabarcatechesis.com/" className="catechism-link">Syro-Malabar Catechism</a></li>
                    <li><a href="https://irinjalakudadiocese.com/" className="catechism-link">Irinjalakuda Diocese</a></li>
                    <li><a href="https://vidyajyotiijk.com/" className="catechism-link">Vidyajyoti Catechism</a></li>
                </ul>
                <ul>
                    <li><a href="https://www.instagram.com/vasupuram_catechism?igsh=MTRvcDRybHc1dG9rdg==" className="catechism-link"><img src="/images/insta.png" alt="Vasupuram Catechism" />Catechism Unit Vasupuram</a></li>
                    <li><a href="https://www.instagram.com/kcym__vasupuram__?igsh=MWZqZWEzajZ4Zzl1OQ==" className="catechism-link"><img src="/images/insta.png" alt="KCYM Vasupuram" />K.C.Y.M Vasupuram</a></li>
                    <li><a href="https://www.facebook.com/share/15sdkwiTG8/" className="catechism-link"><img src="/images/face.png" alt="KCYM Vasupuram" />K.C.Y.M Vasupuram</a></li>
                    <li><a href="https://www.youtube.com/@kcymvasupuram9096" className="catechism-link"><img src="/images/youtube.png" alt="KCYM Vasupuram" />K.C.Y.M Vasupuram</a></li>
                </ul>
            </footer>
        </div >
    );
};